/**
 * sco design system — font size tokens.
 * Source of truth. Edit directly.
 */

import { defineTokens } from '@chakra-ui/react'

export const fontSizes = defineTokens.fontSizes({
  '2xs': {
    value: '0.625em',
  },
  xs: {
    value: '0.75em',
  },
  sm: {
    value: '0.875em',
  },
  md: {
    value: '1em',
  },
  lg: {
    value: '1.125em',
  },
  xl: {
    value: '1.25em',
  },
  '2xl': {
    value: '1.5em',
  },
  '3xl': {
    value: '1.875em',
  },
  '4xl': {
    value: '2.25em',
  },
  '5xl': {
    value: '3em',
  },
  '6xl': {
    value: '3.75em',
  },
  '7xl': {
    value: '4.5em',
  },
  '8xl': {
    value: '6em',
  },
  '9xl': {
    value: '8em',
  },
})
